module.exports = __webpack_public_path__ + "static/media/salidaEmergencia.d0401225.png";